import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=45351ee2"
import script from "./topbar.vue?vue&type=script&lang=js"
export * from "./topbar.vue?vue&type=script&lang=js"
import style0 from "./topbar.vue?vue&type=style&index=0&id=45351ee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports